export default "assets/images/logo-1e57a696.png";